import { render } from "./FeatInfoArticleBox.vue?vue&type=template&id=e9b1311c&scoped=true"
import script from "./FeatInfoArticleBox.vue?vue&type=script&lang=js"
export * from "./FeatInfoArticleBox.vue?vue&type=script&lang=js"

import "./FeatInfoArticleBox.vue?vue&type=style&index=0&id=e9b1311c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b1311c"]])

export default __exports__